export default "__VITE_ASSET__ufLA6kyJ__"